/*
 *   File : secondary-button.js
 *   Author : https://evoqins.com
 *   Description : CTA component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from 'react';

// Assets 
import Loader from "../../Assets/Images/loader-light.gif";

// Styles
import Styles from "../../Styles/Component/button.module.scss";

//Custom components
import { Icon } from '../Icon';

const SecondaryButton = (props) => {

    return (
        <button className={`${Styles.secondary_button} ${props.className} ${props.fontColor ? props.fontColor : "e-text-chinese-black"} ${props.status ? `px-4 padding-10px-tb` : `${props.padding ? props.padding : "px-3 padding-14px-tb"} `} ${props.disabled === true ? 'opacity-7' : ''} border-radius-8 border-0 e-font-14 e-bg-lavender-extra-dark border-transparent e-alt-font-lato e-font-weight-600 line-height-20px`}
            data-bs-toggle={props.toggle}
            data-bs-target={props.target}
            data-bs-cancel={props.cancel}
            data-bs-dismiss={props.dismiss}
            disabled={props.disabled}
            id={props.id}
            onClick={(e) => props.onPress(e)}>

            {
                props.status ?
                    <img src={Loader}
                        className={`${props.loaderClass} w-20px h-20px margin-2px-block`}
                        alt='loader' />
                    :
                    <div className='d-flex align-items-center gap-1 gap-sm-2 justify-content-center'>
                        {
                            props.icon === true && props.iconFirst &&
                            <Icon icon={props.iconName ? props.iconName : "plus-icon"}
                                color={props.iconColor ? props.iconColor : ""}
                                className="d-flex"
                                size="12px" />
                        }
                        <span>{props.name}</span>
                        {
                            props.icon === true && props.iconFirst === false &&
                            <Icon icon={props.iconName ? props.iconName : "plus-icon"}
                                color={props.iconColor ? props.iconColor : ""}
                                className="d-flex"
                                size="12px" />
                        }
                    </div>
            }
        </button>
    )
}

SecondaryButton.defaultProps = {
    onPress: () => { },
    className: null,
    id: null,
    name: null,
    icon: null
};

export default memo(SecondaryButton);